import { Banner } from '@/components/ui/banner'
import { Button } from '@/components/ui/button'

interface IssueBannerProps {
  variant: 'error' | 'warning'
  lines: string[]
  /** Makes the whole banner one button. */
  onClick?: () => void
  /** Makes each line its own button, e.g. to jump to the field it names. */
  onLineClick?: (index: number) => void
  /** Adds a close button at the top right. */
  onDismiss?: () => void
}

/**
 * Everything one card owes, at one severity, in a single banner. Per-item rows
 * turned the equipment card into a stack of six near-identical lines.
 */
export function IssueBanner({ variant, lines, onClick, onLineClick, onDismiss }: IssueBannerProps) {
  if (!lines.length) return null
  const line = (text: string, index: number) =>
    onLineClick ? (
      <Button
        type="button"
        variant="link"
        onClick={() => onLineClick(index)}
        className="h-auto p-0 text-left font-normal whitespace-normal text-current underline underline-offset-2 hover:text-current"
      >
        {text}
      </Button>
    ) : (
      text
    )
  const body =
    lines.length === 1 ? (
      line(lines[0], 0)
    ) : (
      <ul className="ml-4 flex list-disc flex-col gap-1">
        {lines.map((text, index) => (
          <li key={`${index}-${text}`}>{line(text, index)}</li>
        ))}
      </ul>
    )
  const banner = (
    <Banner variant={variant} small align={lines.length === 1 ? 'center' : 'start'} onDismiss={onDismiss}>
      {body}
    </Banner>
  )
  if (!onClick) return banner
  return (
    <button type="button" onClick={onClick} className="w-full cursor-pointer text-left">
      {banner}
    </button>
  )
}
